var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 6V0H11V6H9ZM7 0C7.26522 0 7.51957 0.105357 7.70711 0.292893C7.89464 0.48043 8 0.734784 8 1V6C8 6.275 7.89 6.525 7.705 6.705L4.415 10L3.885 9.47C3.75 9.335 3.665 9.15 3.665 8.94L3.68 8.785L4.155 6.5H1C0.445 6.5 0 6.05 0 5.5V4.5C0 4.37 0.025 4.25 0.07 4.135L1.58 0.61C1.73 0.25 2.085 0 2.5 0H7ZM7 1H2.485L1 4.5V5.5H5.39L4.825 8.16L7 5.985V1Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.c8f99892.svg";
export { ForwardRef as ReactComponent };